import { useScreenOrientation } from 'components/ProvidersContainer/ScreenOrientationProvider';

export const useIsPortrait = (): boolean => {
  const orientation = useScreenOrientation();
  return orientation === 'PORTRAIT' || orientation === 'PORTRAIT-UPSIDEDOWN';
};
